// index.js
import React from 'react'
import ReactDOM from 'react-dom/client' // измените импорт на 'react-dom/client'
import { Provider } from 'react-redux'
import store from './store'
import App from './App'
import { Buffer } from 'buffer'
const root = ReactDOM.createRoot(document.getElementById('root'))
if (typeof window.Buffer === 'undefined') {
  window.Buffer = Buffer
}
root.render(
  <Provider store={store}>
    <App />
  </Provider>
)
